import { useMediaQuery } from "@mantine/hooks";
import { Table } from "antd";
import React from "react";
import BannerCard from "../../common/components/BannerCard";
import TimeCardApprovalMobile from "./timecard-approval-mobile";

const TimecardApprovalTable = ({ ...props }) => {
    const { cols, title, loading } = props;
    const data = [...props.data];
    if (data.length > 1) {
        data.sort(function (a, b) {
            var textA = a.lastName.toUpperCase();
            var textB = b.lastName.toUpperCase();

            return textA.localeCompare(textB);
        });
    }
  const isMobile = useMediaQuery("(max-width:768px)");

  return isMobile ? (
    <TimeCardApprovalMobile data={data} title={title} />
  ) : (
    <>
      <br />
      <BannerCard title={title}>
        <Table loading={loading} dataSource={data} columns={cols} size="small" bordered={false} scroll={{ x: 720 }} />
      </BannerCard>
    </>
  );
};

export default TimecardApprovalTable;
